import script from "./universal_styles.vue?vue&type=script&lang=js"
export * from "./universal_styles.vue?vue&type=script&lang=js"

import "./universal_styles.vue?vue&type=style&index=0&id=5205f6e4&lang=scss"

const __exports__ = script;

export default __exports__